
				var addMethods = require("../../../../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["CustomTypeScriptWorker"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "7378c02270f6a6af90cb.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			